export default {
  //get all SUPERADMIN_TEACHERs
  GET_SUPERADMIN_TEACHERS_REQUEST: "GET_SUPERADMIN_TEACHERS_REQUEST",
  GET_SUPERADMIN_TEACHERS_SUCCESS: "GET_SUPERADMIN_TEACHERS_SUCCESS",
  GET_SUPERADMIN_TEACHERS_FAIL: "GET_SUPERADMIN_TEACHERS_FAIL",

  //edit SUPERADMIN_TEACHERs
  EDIT_SUPERADMIN_TEACHER_REQUEST: "EDIT_SUPERADMIN_TEACHER_REQUEST",
  EDIT_SUPERADMIN_TEACHER_SUCCESS: "EDIT_SUPERADMIN_TEACHER_SUCCESS",
  EDIT_SUPERADMIN_TEACHER_FAIL: "EDIT_SUPERADMIN_TEACHER_FAIL",

  //create SUPERADMIN_TEACHER
  CREATE_SUPERADMIN_TEACHER_REQUEST: "CREATE_SUPERADMIN_TEACHER_REQUEST",
  CREATE_SUPERADMIN_TEACHER_SUCCESS: "CREATE_SUPERADMIN_TEACHER_SUCCESS",
  CREATE_SUPERADMIN_TEACHER_FAIL: "CREATE_SUPERADMIN_TEACHER_FAIL",

  DELETE_SUPERADMIN_TEACHER_REQUEST: "DELETE_SUPERADMIN_TEACHER_REQUEST",
  DELETE_SUPERADMIN_TEACHER_SUCCESS: "DELETE_SUPERADMIN_TEACHER_SUCCESS",
  DELETE_SUPERADMIN_TEACHER_FAIL: "DELETE_SUPERADMIN_TEACHER_FAIL",

  GET_SUPERADMIN_TEACHER_REQUEST: "GET_SUPERADMIN_TEACHER_REQUEST",
  GET_SUPERADMIN_TEACHER_SUCCESS: "GET_SUPERADMIN_TEACHER_SUCCESS",
  GET_SUPERADMIN_TEACHER_FAIL: "GET_SUPERADMIN_TEACHER_FAIL",

  //loading
  ADD_SUPERADMIN_TEACHERS_LOADING: "ADD_SUPERADMIN_TEACHERS_LOADING",

  ADD_TEACHER_ADMIN_REQUEST: "ADD_TEACHER_ADMIN_REQUEST",
  ADD_TEACHER_ADMIN_SUCCESS: "ADD_TEACHER_ADMIN_SUCCESS",
  ADD_TEACHER_ADMIN_FAIL: "ADD_TEACHER_ADMIN_FAIL",
};
